import React from 'react';
import {
    Filter,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import CustomTableList from './CustomTableList';
import ElipsizeTextField from '../fields/ElipsizeTextField'

class SuggestionList extends CustomTableList {

    myFilter = (props) => (
        <Filter {...props}>
            <ReferenceInput label="User" source="user" reference="users" allowEmpty >
                <AutocompleteInput optionText="name" />
            </ReferenceInput>

        </Filter>
    );

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'message') {
            fieldList.push(<ElipsizeTextField source={fieldName} field={fieldName} maxLength={100}/>)
            return true
        }
        return false
    }

    customSort() {
        return { field: 'createdAt', order: 'DESC' }
    }
}

export default SuggestionList;
